import React from "react";
import style from "./qualityReportForm.module.scss";
import Spreadsheet from "../../../static/images/ExportSpredsheet.svg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getQualityAssuranceCountData, setOverviewDownloadCsvfile, setqaOverViewPagesData, setQualityReportPayload } from "../../../app/woundReportSlice";

export const QualityReportOverview = ({ selectedDivOption, setSelectedDivOption, setTabIndex, setWoundProgressValue, tempPayload }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const overViewData = useSelector((state) => state.woundreport.qualityAssuranceOverViewData);
  const qualityReportPayload = useSelector((state) => state.woundreport.qualityReportPayload);

  const handleRedirect = (path) => {
    dispatch(setqaOverViewPagesData({}));
    dispatch(setOverviewDownloadCsvfile({}));
    history.push({
      pathname: `qualityReport/${path}`,
      state: true,
    });
  };

  const optionSelected = (e) => {
      setTabIndex(0);
      dispatch(setQualityReportPayload({ ...qualityReportPayload, tabIndex: 0 }));
      setSelectedDivOption(e);
      if (e === "Image Capture") {
        setWoundProgressValue("Taken Timely");
        let qualitytPayload = { ...qualityReportPayload, section: e, subsection: "Taken Timely" };
        dispatch(setQualityReportPayload(qualitytPayload));
        let wountCountPayload = {
          ...tempPayload,
          section: e,
          subsection: "Taken Timely",
        };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
      } else if (e === "Assessments") {
        setWoundProgressValue("Performed Timely");
        let qualitytPayload = { ...qualityReportPayload, section: e, subsection: "Performed Timely" };
        dispatch(setQualityReportPayload(qualitytPayload));
        let wountCountPayload = {
          ...tempPayload,
          section: e,
          subsection: "Performed Timely",
        };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
      } else if (e === "Measurements") {
        setWoundProgressValue("No Surface Area");
        let qualitytPayload = { ...qualityReportPayload, section: e, subsection: "No Surface Area" };
        dispatch(setQualityReportPayload(qualitytPayload));
        let wountCountPayload = {
          ...tempPayload,
          section: e,
          subsection: "No Surface Area",
        };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
      } else if (e === "Treatments") {
        setWoundProgressValue("Dressing Appearance Not Set");
        let qualitytPayload = { ...qualityReportPayload, section: e, subsection: "Dressing Appearance Not Set" };
        dispatch(setQualityReportPayload(qualitytPayload));
        let wountCountPayload = {
          ...tempPayload,
          section: e,
          subsection: "Dressing Appearance Not Set",
        };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
      }
    };

  const QUALITY_REPORT_OVERVIEW_CONFIG = [
    {
      id: "pendingPhoto",
      label: "Missing Photos",
      className: style.pend_photos,
      value: overViewData?.pendingPhotos,
      redirectKey: "pendingphotos",
    },
    {
      id: "pendingAssessments",
      label: "Assessments not signed",
      className: style.pend_assessments,
      value: overViewData?.pendingAssessments,
      redirectKey: "pendingassessments",
    },
    {
      id: "pendingReviews",
      label: "Assessments not locked",
      className: style.pend_review,
      value: overViewData?.pendingReviews,
      redirectKey: "pendingreviews",
    },
    {
      id: "completedAssessments",
      label: "Completed Assessments",
      className: style.comp_assess,
      value: overViewData?.completedAssessments,
      redirectKey: "completedassessments",
    },
  ];

  const QUALITY_SCORE_CONFIG = [
    {
      key: "Image Capture",
      crdClass: "crd_opt_1",
      labelClass: style.qu_image,
      label: "Image Capture",
    },
    {
      key: "Assessments",
      crdClass: "crd_opt_2",
      labelClass: style.qu_assses,
      label: "Assessments",
    },
    {
      key: "Measurements",
      crdClass: "crd_opt_3",
      labelClass: style.qu_measure,
      label: "Measurements",
    },
    {
      key: "Treatments",
      crdClass: "crd_opt_4",
      labelClass: style.qu_treat,
      label: "Treatments",
    },
  ];

  return (
    <div className={style.overview_blk}>
      <div className={style.overview_top}>
        <p className={style.overview_title}>Overview</p>
        <span className={style.down_spread} onClick={() => handleRedirect("pdfdownload")}>
          <img src={Spreadsheet} alt="" />
          <label> Download as PDF </label>
        </span>
      </div>
      <div className={style.overview_btm}>
        {QUALITY_REPORT_OVERVIEW_CONFIG.map(({ id, label, className, redirectKey, value }) => (
          <p key={id}>
            <label className={className}>{label}</label>
            <span id={id} className={`${style.commonCusrsor}`} onClick={() => handleRedirect(redirectKey)}>
              {value}
            </span>
          </p>
        ))}
      </div>
      <div className={style.quality_score}>
        {QUALITY_SCORE_CONFIG.map(({ key, label, labelClass, crdClass }) => (
          <div
            key={key}
            className={`${crdClass} ${style.quality_percent} ${selectedDivOption === key ? style.active : ""}`}
            onClick={() => optionSelected(key)}
          >
            <label className={`${style.quality_top} ${labelClass}`}>{label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
